import * as React from 'react';
import S from './AvailabilityTabs.styles';
const AvailabilityTabs = ({ activeId, onAvailabilityChange, options }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.FormLabel, null, options.label),
        React.createElement(S.SelectBox, { name: "availability", value: activeId, onChange: (e) => onAvailabilityChange(e.target.value) }, options.options.map((option) => (React.createElement("option", { key: option.id, value: option.value }, option.name))))));
};
export default AvailabilityTabs;
